module.exports = __webpack_public_path__ + "img/logo-energie-cardio.075d2ba9.svg";